// extracted by mini-css-extract-plugin
export default {"header":"CategoryList_header__JDUrb","item":"CategoryList_item__Hluaz"};